import { Button, Form, Input, Modal, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const EditBusiness = ({ open, close, data, getMyCommissaryInfo }) => {
  const [provinceList, setProvinceList] = useState({ data: [], ready: false });
  const [cityList, setCityList] = useState({ data: [], ready: false });
  const [barangayList, setBarangayList] = useState({ data: [], ready: false });
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const getAllProvinces = () => {
    axios
      .get("user/admin/province-list")
      .then((response) => {
        const data = response.data;
        setProvinceList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetCityByProvince = (value) => {
    var params = { province_description: value };
    setCityList({ data: [], ready: false });
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/admin/city-list", { params })
      .then((response) => {
        const data = response.data;
        setCityList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetBarangayByCity = (value) => {
    var params = { city_municipality_description: value };
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/admin/barangay-list", { params })
      .then((response) => {
        const data = response.data;
        setBarangayList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllProvinces();
  }, []);

  const handleUpdateBusinessCom = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    axios
      .post("user/commissary/update-business", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated business successfully.");
          setTimeout(() => {
            close();
            getMyCommissaryInfo();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{
          business_name: data.business_name,
          business_province: data.business_province,
          business_city: data.business_city,
          business_barangay: data.business_barangay,
          business_street: data.business_street,
        }}
        onFinish={handleUpdateBusinessCom}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="business_name"
            label="Business Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set business" size="large" />
          </Form.Item>

          <Form.Item
            name="business_province"
            label="Province"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select province"
              onChange={handleGetCityByProvince}
              size="large"
              showSearch
            >
              {provinceList.data.length > 0 ? (
                provinceList.data.map((data, index) => (
                  <Select.Option value={data.province_description} key={index}>
                    {data.province_description}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No province found!</Select.Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="business_city"
            label="City"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select city"
              onChange={handleGetBarangayByCity}
              size="large"
              showSearch
            >
              {cityList.data.length > 0 ? (
                cityList.data.map((data, index) => (
                  <Select.Option
                    value={data.city_municipality_description}
                    key={index}
                  >
                    {data.city_municipality_description}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No city found!</Select.Option>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="business_barangay"
            label="Barangay"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select barangay"
              // onChange={handleGetBarangayByCity}
              size="large"
              showSearch
              style={{ textTransform: "uppercase" }}
            >
              {barangayList.data.length > 0 ? (
                barangayList.data.map((data, index) => (
                  <Select.Option
                    value={data.barangay_description}
                    key={index}
                    style={{ textTransform: "uppercase" }}
                  >
                    {data.barangay_description}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No barangay found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="business_street"
            label="Street|House No.|Bldg. No.|Apartment"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea
              placeholder="Set street/house/bldg./apt"
              autoSize
              size="large"
              style={{ textTransform: "uppercase" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditBusiness;
